import { useRouter } from 'expo-router'
import { type PropsWithChildren, useEffect } from 'react'

import { useAuthentication } from '@/src/features/auth/services/useAuthentication'
import { Protected } from '@/src/features/auth/ui/components/Protected'
import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'

type TSettingsScreenProtectedNavigationContentProps = PropsWithChildren<{
  shouldClearToken: boolean
  invalidUpdateParametersToken: boolean | undefined
  doesUserIdMismatch: boolean
  userIdMatch: boolean
  updateParametersToken: string | undefined
  isGuestInfoInvalid: boolean
}> &
  TSearchParamsParam

export const SettingsScreensProtectedNavigationContent = ({
  children,
  shouldClearToken,
  searchParams,
  invalidUpdateParametersToken,
  doesUserIdMismatch,
  userIdMatch,
  updateParametersToken,
  isGuestInfoInvalid,
}: TSettingsScreenProtectedNavigationContentProps) => {
  const { logout } = useAuthentication()

  const isLoggedIn = getIsLoggedIn()
  const { setParams } = useRouter()

  useEffect(() => {
    if (shouldClearToken) {
      setParams({ updateParametersToken: undefined })
    }
  }, [shouldClearToken, setParams])

  if (doesUserIdMismatch || invalidUpdateParametersToken) {
    logout(false)

    return <Protected searchParams={searchParams} />
  }

  if (userIdMatch) {
    return children
  }

  if (isGuestInfoInvalid) {
    return <Protected searchParams={searchParams} />
  }

  const hasNoAccessRights = !isLoggedIn && !updateParametersToken
  if (hasNoAccessRights) return <Protected searchParams={searchParams} />

  return children
}
